import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

const apiPrefix = window.location.hostname === 'localhost' ? '' : '/api';
const get = (url) => axios.get(`${apiPrefix}${url}`, { withCredentials: true }).then(r => r.data);

export const useAdminUsers = () => useQuery({
    queryKey: ['admin', 'users'],
    queryFn: () => get('/admin/users'),
});

export const useAdminUser = (id) => useQuery({
    queryKey: ['admin', 'user', id],
    queryFn: () => get(`/admin/users/${id}`),
    enabled: !!id,
});

export const useCreateUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.post(`${apiPrefix}/admin/users`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin', 'users'] }),
    });
};

export const useUpdateUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, ...data }) => axios.put(`${apiPrefix}/admin/users/${id}`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin'] }),
    });
};

export const useDeleteUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => axios.delete(`${apiPrefix}/admin/users/${id}`, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin', 'users'] }),
    });
};

export const useReactivateUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => axios.put(`${apiPrefix}/admin/users/${id}/reactivate`, {}, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin', 'users'] }),
    });
};
